export const EMAILJS_CONFIG = {
    serviceId: 'service_4hnt6hg',
    templateId: 'template_yvztxox',
    publicKey: 'us9cnFIk4HJGcsA3i'
};

const englishEventTypes = {
    'Фирмено Събитие': 'Corporate Event',
    'Личен Повод': 'Personal Event',
    'Коледно Парти': 'Christmas Party',
    'Друго Събитие': 'Other Event'
};

export function buildReservationEmailParams(fields, language) {
    const isEnglish = String(language || 'bg').toLowerCase().split('-')[0] === 'en';
    const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fields.date || '');
    const eventDate = dateParts ? `${dateParts[3]}.${dateParts[2]}.${dateParts[1]}` : (fields.date || '');
    return {
        ...fields,
        event_name: (isEnglish && englishEventTypes[fields.type]) || fields.type || '',
        event_date: eventDate,
        language: isEnglish ? 'Английски (EN)' : 'Български (BG)',
        // Send a boolean: a nonempty string such as "false" is truthy in templates.
        is_english: isEnglish
    };
}
